export default __webpack_public_path__ + "static/media/thevillaback.eb26580c.jpg";